export default __webpack_public_path__ + "static/media/icn-folder@2x.60af40ce.svg";